<pwj-button
  class="login-btn"
  [variant]="variant()"
  [color]="color()"
  [size]="size()"
  icon="chevron-right"
  [rotateIconInRtl]="true"
  [iconReversePosition]="true"
  (click)="
    !mobileVerified && isUserLoggedIn ? openOtpDialog() : openLoginDialog()
  ">
  @if (title()) {
    {{ title() | translate }}
  } @else {
    <span>
      {{ 'global.login' | translate }}
    </span>
    <span> / </span>
    <span>
      {{ 'global.signup' | translate }}
    </span>
  }
</pwj-button>
